//
// NavigationEvent.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/events/PortableEvent";
import "@sas-dvr/ltjs-commons/models/data/DataValue";

var NavigationEvent = createModule("BIRD::NavigationEvent", ["commons::PortableEvent"], ClosetObject, [
    {
        NAVIGATION_DATA_UPDATE: 50034,
    },
    ,
    ,
    ,
    {
        getNavigationHierarchyName: [7],
        getNavigationLevelIndex: [4],
        getValueList: [[1]],
    },
    ,
    ,
]);
export default NavigationEvent;
